// 根据navItems提炼出符合footer结构的数据
export const footerNavData = [
  {
    title: 'Products & Solutions',
    path: '/product-solution',
    children: [
      {
        title: 'Commercial Energy Storage Systems',
        path: '/solution/medical-solution',
      },
      {
        title: 'Residential Energy Storage Systems',
        path: '/solution/renewable-energy',
      },
      {
        title: 'Centralized PV Storage Systems',
        path: '/solution/green-power-plant',
      },
      {
        title: 'Distributed PV Storage Systems',
        path: '/solution/green-city',
      },
      {
        title: 'Specialty Mobile Power Systems',
        path: '/solution/disaster-relief',
      },
    ],
  },
  {
    title: 'Services & Support',
    path: '/service',
    children: [
      {
        title: 'Carbon Management',
        path: 'https://www.carusg-carbon.com',
      },
      {
        title: 'AI & Data Analytics',
        path: '/ai',
      },
      {
        title: 'Added Value Services',
        path: '/service-support',
      },
      {
        title: 'Project Financing Options',
        path: '/service-support',
      },
    ],
  },
  {
    title: 'Insights',
    path: '/news',
    children: [
      {
        title: 'Government Policies & Regulations',
        path: '/news',
      },
      {
        title: 'Carbon Neutrality & Emissions Reduction',
        path: '/news',
      },
      {
        title: 'Clean Energy Initiatives',
        path: '/news',
      },
    ],
  },
  {
    title: 'About Us',
    path: '/about-us',
    children: [],
  },
]
